'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@algoacademy/design-system/shared/cn';
import { Tabs } from '@algoacademy/design-system/web/navigation/Tabs';
import type { Dispatch, SetStateAction } from 'react';
export const STAFF_MENTORING_PANEL_TAB = {
  DETAILS: 'Szczegóły mentoringu',
  OFFER: 'Wystaw ofertę'
} as const;
export type StaffMentoringPanelTab = (typeof STAFF_MENTORING_PANEL_TAB)[keyof typeof STAFF_MENTORING_PANEL_TAB];
const STAFF_MENTORING_PANEL_TABS = Object.values(STAFF_MENTORING_PANEL_TAB) as StaffMentoringPanelTab[];
type StaffMentoringPanelTabsProps = {
  activeTab: StaffMentoringPanelTab;
  setActiveTab: Dispatch<SetStateAction<StaffMentoringPanelTab>>;
  goalPage?: boolean;
};
export function StaffMentoringPanelTabs(t0) {
  const $ = _c(9);
  const {
    activeTab,
    setActiveTab,
    goalPage: t1
  } = t0;
  const goalPage = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = STAFF_MENTORING_PANEL_TABS.map(_temp);
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== setActiveTab) {
    t3 = tab => setActiveTab(tab as StaffMentoringPanelTab);
    $[1] = setActiveTab;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = goalPage && "dark";
  let t5;
  if ($[3] !== t4) {
    t5 = cn(t4);
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== activeTab || $[6] !== t3 || $[7] !== t5) {
    t6 = <div className="flex w-full justify-start"><Tabs ariaLabel="Sekcja mentoringu" tabs={t2} activeTab={activeTab} setActiveTab={t3} className={t5} /></div>;
    $[5] = activeTab;
    $[6] = t3;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}
function _temp(label) {
  return {
    label
  };
}